import { Link } from 'react-router-dom';
import './Works.scss';
import projects, { tags } from '../data/projects';

const Works = () => (
  <section className="works" id="works">
    <div className="works__header">
      <span className="works__label">01</span>
      <h2 className="works__title">MON TRAVAIL</h2>
    </div>

    <div className="works__grid">
      {projects.slice(0, 9).map(({ id, slug, title, logo, logoHeight, logoInvert, img, tags: projectTags }) => (
        <Link to={`/projet/${slug}`} className="works__item" key={id}>
          <div className="works__img" style={{ backgroundImage: `url(${img})` }} />
          <div className="works__overlay">
            <span className="works__num">{id}</span>
            <div className="works__info">
              {logo
                ? <img src={logo} alt={title} className="works__logo" style={{ ...(logoHeight ? { height: `${logoHeight}px` } : {}), ...(logoInvert ? { filter: 'brightness(0) invert(1)' } : {}) }} />
                : <p className="works__name">{title}</p>
              }
              <div className="works__tags">
                {(projectTags || tags).map(tag => (
                  <span className="works__tag" key={tag}>{tag}</span>
                ))}
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>

    <div className="works__footer">
      <Link to="/projets" className="works__more">TOUS LES PROJETS →</Link>
    </div>
  </section>
);

export default Works;
